import { render } from "./BackingInformationModal.vue?vue&type=template&id=bc38f3d4"
import script from "./BackingInformationModal.vue?vue&type=script&lang=js"
export * from "./BackingInformationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__